function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M16.828 8.585L3.08.456C1.962-.204.251.436.251 2.07v16.253c0 1.465 1.59 2.348 2.828 1.613l13.75-8.124c1.226-.723 1.23-2.504 0-3.227z",
  fill: "#246A73"
});
function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default SvgPlay;